import { Button, Icon, Modal, Textarea } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import React from "react";
import "./components/modal.scss";

class EditMsgTextModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msgText: "",
      showErr: false,
    };
  }

  componentDidMount() {
    const { emailHeading = "Congratulations! You have received a reward." } =
      this.props;
    this.setState({ msgText: emailHeading });
  }

  handleSubmitClick = () => {
    const { msgText } = this.state;
    if (!msgText.length) {
      this.setState({ showErr: true });
    } else {
      this.setState({ showErr: false });
      this.props.updateEmailMsgText(msgText);
    }
  };

  handleInput = (input) => {
    if (input.length <= 600) {
      this.setState({ msgText: input });
    }
  };

  render() {
    const { toggleModal } = this.props;
    const { msgText, showErr } = this.state;
    return (
      <Modal
        isOpen={true}
        style={{ width: "476px", minWidth: "476px" }}
        onClose={() => {
          toggleModal();
        }}
      >
        <Typography
          component="div"
          className="d-flex justify-content-between align-items-center"
        >
          <Typography.H2>Edit Message</Typography.H2>
          <Icon
            iconName="Close"
            onClick={() => {
              toggleModal();
            }}
            size="m"
          />
        </Typography>
        <Typography className="mb-20" color="dark" shade="c200">
          Enter a message to send to your recipient with this email.
        </Typography>

        <div>
          <Textarea
            value={msgText}
            limit={600}
            onChange={(e) => this.handleInput(e.target.value)}
            error={showErr}
            helperText={showErr ? "Message body cannot be left blank." : ""}
          />
        </div>
        <div className="d-flex justify-content-end mt-20">
          <Button
            onClick={() => {
              toggleModal();
            }}
            className="mr-12"
            variant="plain"
          >
            Cancel
          </Button>
          <Button onClick={() => this.handleSubmitClick()}>Save</Button>
        </div>
      </Modal>
    );
  }
}

export default EditMsgTextModal;
